import React from 'react';
import { Helmet } from 'react-helmet';

class NotFoundPage extends React.Component {
    render() {
        return (
            <div>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Página no encontrada | Vivamos el Campo - Turismo Rural</title>
                    {/*<link rel="canonical" href="https://vivamoselcampo.co" />*/}
                </Helmet>

                {/**
                 TODO: Personalizar esta página
                 */}
                <h1>Página no encontrada</h1>
                <p>Lo sentimos, la página que buscas no existe</p>
            </div>
        );
    }
}

export default NotFoundPage;


// WEBPACK FOOTER //
// ./src/views/NotFoundPage/NotFoundPage.js